export default __webpack_public_path__ + "static/media/linkedin.e05ef8d3.svg";